import Languages from "pages/config/Languages";
import { Box, IconButton, MenuItem, Select as MuiSelect } from "@mui/material";
import { eventDispatcher } from "pages/Hooks/useEventListener";
import { LANGUAGE_CHANGE } from "pages/constants/EventKeys";
import * as languageHelper from "pages/Utils/LanguageHelper";

const LanguageSwitcher = (props: any) => {
  const { tiny } = props;
  const currentLanguage = languageHelper.getCurrentLanguage();
  const handleInputChange = (e: any) => {
    const { value } = e.target;
    languageHelper.setCurrentLanguage(value);
    eventDispatcher(LANGUAGE_CHANGE, value);
  };

  return (
    <>
      <MuiSelect
        name="language-switcher"
        sx={{
          height: "fit-content",
          backgroundColor: "white",
        }}
        value={currentLanguage}
        renderValue={(value: any) =>
          tiny ? (
            <IconButton
              aria-label="change Language"
              size="small"
              sx={{
                padding: 0,
                marginRight: -15,
                backgroundColor: "white",
              }}
            >
              <img
                src={`${process.env.PUBLIC_URL + Languages[value].icon}`}
                alt={`${Languages[value].label}`}
                width={"15px"}
              />
            </IconButton>
          ) : (
            <Box display={"flex"} gap={1}>
              <img
                src={`${process.env.PUBLIC_URL + Languages[value].icon}`}
                alt={`${Languages[value].label}`}
                width={"15px"}
              />
              <p>{Languages[value].label}</p>
            </Box>
          )
        }
        onChange={handleInputChange}
        size="small"
        {...(tiny && {
          IconComponent: () => null,
        })}
      >
        {Object.keys(Languages).map((languageCode, i) => (
          <MenuItem key={i} value={languageCode}>
            <Box display={"flex"} gap={1}>
              <img
                src={`${process.env.PUBLIC_URL + Languages[languageCode].icon}`}
                alt={`${Languages[languageCode].label}`}
                width={"15px"}
              />
              <p>{Languages[languageCode].label}</p>
            </Box>
          </MenuItem>
        ))}
      </MuiSelect>
    </>
  );
};

export default LanguageSwitcher;
